import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChartConfiguration, ChartData } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

// Angular Material Imports
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';

import { Conversation } from '../../../services/conversation';

@Component({
  selector: 'app-outcome-distribution',
  standalone: true,
  imports: [
    CommonModule, FormsModule, BaseChartDirective, MatFormFieldModule,
    MatInputModule, MatDatepickerModule, MatNativeDateModule,
    MatButtonModule, MatTableModule, MatCardModule, MatTabsModule
  ],
  templateUrl: './outcome-distribution.component.html',
  // styleUrls: ['../category-distribution/category-distribution.component.scss'] // Reusing your existing styles
  styleUrls: ['./outcome-rate.component.scss']
})
export class OutcomeDistributionComponent implements OnInit {
  @Input() globalStartDate!: Date;
@Input() globalEndDate!: Date;
  tableData: any[] = [];
  startDate = new Date();
  endDate = new Date();

  // Chart Configuration
  barChartData: ChartData<'bar'> = { labels: [], datasets: [] };
  barChartOptions: ChartConfiguration<'bar'>['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: { stacked: true, title: { display: true, text: 'Category' } },
      y: { stacked: true, title: { display: true, text: 'Outcome Count' } }
    },
    plugins: { legend: { position: 'right' } }
  };

  private outcomeColors: Record<string, string> = {
  'Satisfied': '#10b981',
  'Indifferent': '#f59e0b',
  'Not Satisfied': '#ef4444'
};

  constructor(private conversationService: Conversation) {
    this.startDate.setDate(this.endDate.getDate() - 7);
  }

  ngOnInit(): void {
    this.fetchOutcomeDistribution();
  }

  ngOnChanges(changes: SimpleChanges) {
  if (changes['globalStartDate'] || changes['globalEndDate']) {
    this.startDate = this.globalStartDate;
    this.endDate = this.globalEndDate;
    this.fetchOutcomeDistribution(); // Your existing fetch/load function
  }
}

  fetchOutcomeDistribution(): void {
    const start = this.startDate.toISOString().split('T')[0];
    const end = this.endDate.toISOString().split('T')[0];

    this.conversationService.getOutcomeDistribution(start, end).subscribe(response => {
      const data = response.data ?? [];
      this.tableData = data;
      this.processChartData(data);
    });
  }

  private processChartData(data: any[]): void {
  const categories = [...new Set(data.map(item => item.conversation_category))];
  const outcomes = [...new Set(data.map(item => item.interaction_outcome))];

  const datasets = outcomes.map(outcome => {
    return {
      label: outcome,
      backgroundColor: this.outcomeColors[outcome] || '#94a3b8', // fallback gray for any unmapped outcome
      data: categories.map(cat => {
        const found = data.find(d => d.conversation_category === cat && d.interaction_outcome === outcome);
        return found ? found.count : 0;
      })
    };
  });

  this.barChartData = { labels: categories, datasets };
}
}